<div
  class="w-[400px] h-[550px] rounded-[50%] bg-action-secondary-30 blur-3xl absolute bottom-[10px] right-[-10px] z-[-1] rotate-[45deg]"
></div>
<div
  class="w-[400px] h-[550px] rounded-[50%] bg-action-secondary-30 blur-3xl absolute top-[80px] left-[160px] z-[-1] rotate-[-45deg]"
></div>
<div class="flex h-full w-full overflow-hidden">
  <!-- Sidebar -->
  <div class="flex flex-col gap-5 w-[266px] shrink-0 pl-4 pb-4 pt-6">
    <div class="flex items-center gap-2 text-action-secondary dark:text-action-secondary-text pl-2">
      <svg-icon key="ai-52" size="32" />
      <span class="text-lg font-semibold">{{ 'ai-assistant.optimo-ai' | translate }}</span>
    </div>
    <app-ai-assistant-sidebar class="h-full" />
  </div>

  <!-- Main content -->
  <div class="flex flex-col grow">
    <!-- Header -->
    <div class="flex shrink-0 justify-end gap-2 p-6">
      <button type="button" class="text-action-secondary dark:text-action-secondary-text p-1" (click)="onMinimize()">
        <svg-icon key="arrows-in-32" size="24" />
      </button>
      <button type="button" class="text-action-secondary dark:text-action-secondary-text p-1" (click)="onClose()">
        <svg-icon key="close-v-2-24" size="24" />
      </button>
    </div>

    @if (aiService.isNewChat()) {
      <div class="flex flex-col grow items-center justify-center px-10 overflow-y-auto">
        <div class="flex flex-col w-full max-w-[840px]">
          <div class="flex flex-col items-center gap-3 text-action-secondary dark:text-action-secondary-text">
            <svg-icon key="ai-52" size="48" />
            <span class="text-2xl font-medium">{{ 'ai-assistant.ask-optimo-ai' | translate }}</span>
          </div>

          <div class="mt-[100px]">
            <app-ai-composer
              [(value)]="composerValue"
              [disabled]="aiService.composerDisabled()"
              [uiContext]="aiService.uiContext()"
              (messageSent)="onMessageSent($event)"
            />
          </div>

          <div class="mt-7 flex flex-col items-start gap-2">
            <p class="text-xs text-foreground-primary-60">{{ 'ai-assistant.suggestions.title' | translate }}</p>
            <div class="flex flex-wrap gap-2">
              @for (suggestion of suggestionKeys; track suggestion) {
                @let suggestionText = suggestion | translate;
                <button
                  type="button"
                  class="text-left text-sm font-medium text-action-secondary dark:text-foreground-primary-100 bg-background-container-primary hover:bg-background-container-secondary rounded-radius-secondary px-2 py-2 transition-colors"
                  (click)="onSuggestionClicked(suggestionText)"
                >
                  {{ suggestionText }}
                </button>
              }
            </div>
          </div>

          <app-ai-assistant-prompt-presets
            [promptPresets]="aiService.promptPresets()"
            [isLoading]="aiService.promptPresetsLoading()"
            [disabled]="aiService.composerDisabled()"
            (promptPresetSelected)="onPromptPresetSelected($event)"
          />
        </div>
      </div>
    } @else {
      <app-ai-message-list
        [messages]="aiService.messages()"
        [isStreaming]="aiService.isStreaming()"
        [showTypingIndicator]="aiService.showTypingIndicator()"
        [showSuggestions]="false"
        [messagesLoading]="aiService.messagesLoading()"
        class="grow overflow-hidden px-10"
      />

      <div class="px-[56px] pb-6 pt-3 shrink-0">
        <app-ai-composer
          [(value)]="composerValue"
          [disabled]="aiService.composerDisabled()"
          [uiContext]="aiService.uiContext()"
          (messageSent)="onMessageSent($event)"
        />
      </div>
    }
  </div>
</div>
